import { getApiBaseUrl, getAuthToken } from './api';

function authHeaders() {
  const token = getAuthToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

async function request(path, options = {}) {
  const res = await fetch(`${getApiBaseUrl()}${path}`, {
    ...options,
    headers: { ...authHeaders(), ...(options.headers || {}) }
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.message || 'Unable to load students.');
    err.status = res.status;
    err.code = data.code;
    err.data = data;
    throw err;
  }
  return data;
}

const qs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  const s = search.toString();
  return s ? `?${s}` : '';
};

export const teacherStudentsApi = {
  overview: () => request('/api/teacher-students/overview'),
  learningPaths: () => request('/api/teacher-students/learning-paths'),
  pathDetail: (pathId, filters = {}) => request(`/api/teacher-students/learning-paths/${encodeURIComponent(pathId)}${qs(filters)}`),
  createPathGroup: (pathId, body) => request(`/api/teacher-students/learning-paths/${encodeURIComponent(pathId)}/groups`, {
    method: 'POST',
    body: JSON.stringify(body)
  }),
  group: (groupId, params = {}) => request(`/api/teacher-students/groups/${encodeURIComponent(groupId)}${qs(params)}`),
  updateGroup: (groupId, body) => request(`/api/teacher-students/groups/${encodeURIComponent(groupId)}`, {
    method: 'PATCH',
    body: JSON.stringify(body)
  }),
  deleteGroup: (groupId) => request(`/api/teacher-students/groups/${encodeURIComponent(groupId)}`, { method: 'DELETE' }),
  addStudent: (groupId, studentId) => request(`/api/teacher-students/groups/${encodeURIComponent(groupId)}/students`, {
    method: 'POST',
    body: JSON.stringify({ studentId })
  }),
  removeStudent: (groupId, studentId) => request(`/api/teacher-students/groups/${encodeURIComponent(groupId)}/students/${encodeURIComponent(studentId)}`, {
    method: 'DELETE'
  }),
  searchStudents: (q) => request(`/api/teacher-students/students/search${qs({ q })}`),
  students: (params = {}) => request(`/api/teacher-students/students${qs(params)}`),
  profile: (studentId, params = {}) => request(`/api/teacher-students/students/${encodeURIComponent(studentId)}/profile${qs(params)}`),
  courses: () => request('/api/teacher-students/courses'),
  course: (courseId, params = {}) => request(`/api/teacher-students/courses/${encodeURIComponent(courseId)}${qs(params)}`),
  createCourseGroup: (courseId, body) => request(`/api/teacher-students/courses/${encodeURIComponent(courseId)}/groups`, {
    method: 'POST',
    body: JSON.stringify(body)
  })
};

export function parseMyStudentsLocation(pathname) {
  const raw = String(pathname || '');
  const rest = raw.replace(/^\/teacher-dashboard\/my-students\/?/, '');
  if (raw === '/teacher-dashboard/my-students' || rest === '' || rest === raw) {
    if (raw.startsWith('/teacher-dashboard/my-students')) {
      if (!rest || rest === '/') return { view: 'landing' };
    } else {
      return { view: 'landing' };
    }
  }
  const parts = rest.split('/').filter(Boolean);
  if (parts[0] === 'learning-paths') {
    if (!parts[1]) return { view: 'learning-paths' };
    const pathId = parts[1];
    if (parts[2] === 'groups' && parts[3]) {
      if (parts[4] === 'students' && parts[5]) {
        return { view: 'student', pathId, groupId: parts[3], studentId: parts[5] };
      }
      return { view: 'group', pathId, groupId: parts[3] };
    }
    return { view: 'path', pathId };
  }
  if (parts[0] === 'courses') {
    if (!parts[1]) return { view: 'courses' };
    const courseId = parts[1];
    if (parts[2] === 'groups' && parts[3]) {
      if (parts[4] === 'students' && parts[5]) {
        return { view: 'student', courseId, groupId: parts[3], studentId: parts[5] };
      }
      return { view: 'group', courseId, groupId: parts[3] };
    }
    if (parts[2] === 'students' && parts[3]) {
      return { view: 'student', courseId, studentId: parts[3] };
    }
    return { view: 'course', courseId };
  }
  return { view: 'landing' };
}
